import PublishedInFilterSelector from './PublishedInFilterSelector'
import { getBooleanSelectorItems, getDateSelectorItems, getRangeSelectorItems, normalizeCategories } from './utils'
import { ParentCategory } from '../../category-selector/CategorySelector'
import SimpleFilterSelector from './SimpleFilterSelector'
import { ContentType, IdeationStatus, ModerationLabel, ModeratorTag } from './types'
import DynamicFilterSelector from './DynamicFilterSelector'
import { FilterSelector } from '../index'
import DateFilterSelector from './DateFilterSelector'
import RadioInputFilterSelector from './RadioInputFilterSelector'
import RadioFilterSelector from './RadioFilterSelector'

export const separator = () => ({ id: 'separator', type: 'separator' })

export const publishedIn = (categories: ParentCategory[]) : FilterSelector => ({
  id: 'category',
  name: 'Published in',
  type: 'simple',
  items: normalizeCategories(categories),
  component: PublishedInFilterSelector
})

export const contentType = (contentTypes: ContentType[]) : FilterSelector => ({
  id: 'contentType',
  name: 'Content type',
  type: 'simple',
  items: contentTypes.map((contentType, idx) =>
    ({ id: idx,
      name: `${contentType.charAt(0).toUpperCase()}${contentType.replace(/([A-Z])/g, ' $1').slice(1)}`,
      value: contentType })),
  component: SimpleFilterSelector
})

export const assignedModerator = () : FilterSelector => ({
  id: 'assignedModerator',
  type: 'dynamic',
  name: 'Assigned moderator',
  items: [{ id: '', name: 'Unassigned', icon: 'user' }],
  component: DynamicFilterSelector,
  fetchUrl: '/member/getModerators?query='
})

export const author = () : FilterSelector => ({
  id: 'author',
  type: 'dynamic',
  name: 'Author',
  items: [],
  component: DynamicFilterSelector,
  fetchUrl: '/member/getAuthors?query='
})

export const moderationLabel = (moderationLabels: ModerationLabel[]) : FilterSelector => ({
  id: 'moderationLabel',
  type: 'simple',
  name: 'Moderation label',
  items: moderationLabels.map((moderationLabel: ModerationLabel) =>
    ({ id: moderationLabel.id,
      name: moderationLabel.title,
      value: moderationLabel.title })),
  component: SimpleFilterSelector,
  isSearchable: true
})

export const moderatorTag = (moderatorTags: ModeratorTag[]) : FilterSelector => ({
  id: 'moderatorTag',
  type: 'simple',
  name: 'Moderation tag',
  items: moderatorTags.map((moderatorTag: ModeratorTag) =>
    ({ id: moderatorTag.id,
      name: moderatorTag.text,
      value: moderatorTag.text })),
  component: SimpleFilterSelector,
  isSearchable: true
})

export const publishedAt = () : FilterSelector => ({
  id: 'publishedAt',
  type: 'date',
  name: 'Publish date',
  items: getDateSelectorItems(),
  component: DateFilterSelector
})

export const lastActivityAt = () : FilterSelector => ({
  id: 'lastActivityAt',
  type: 'date',
  name: 'Last activity date',
  items: getDateSelectorItems(),
  component: DateFilterSelector
})

export const changedIdeationStatusAt = () : FilterSelector => ({
  id: 'changedIdeationStatusAt',
  type: 'date',
  name: 'Last ideation status change',
  items: getDateSelectorItems(),
  component: DateFilterSelector
})

export const ideationStatus = (ideationStatuses: IdeationStatus[], isMain: boolean = false) : FilterSelector => ({
  id: 'ideationStatus',
  type: 'simple',
  name: 'Ideation status',
  items: ideationStatuses.map((ideationStatus: IdeationStatus) =>
    ({ id: ideationStatus.id,
      name: ideationStatus.name,
      value: ideationStatus.name })),
  component: SimpleFilterSelector,
  isSearchable: true,
  isMain
})

export const replies = () : FilterSelector => ({
  id: 'replies',
  type: 'radio-input',
  name: 'Replies',
  items: getRangeSelectorItems(),
  component: RadioInputFilterSelector
})

export const bestAnswer = () : FilterSelector => ({
  id: 'bestAnswer',
  type: 'radio',
  name: 'Best answer',
  items: getBooleanSelectorItems(),
  component: RadioFilterSelector
})

export const pinnedReply = () : FilterSelector => ({
  id: 'pinnedReply',
  type: 'radio',
  name: 'Pinned reply',
  items: getBooleanSelectorItems(),
  component: RadioFilterSelector
})

export const unreadByTeam = () : FilterSelector => ({
  id: 'unreadByTeam',
  type: 'radio',
  name: 'Unread by team',
  items: [{
    id: 1,
    name: 'Unread topic',
    value: 'unreadTopic'
  },
  {
    id: 2,
    name: 'Unread reply',
    value: 'unreadReply'
  },
  {
    id: 3,
    name: 'Unread topic or reply',
    value: 'unreadTopicOrReply'
  },
  {
    id: 4,
    name: 'Read by team',
    value: 'read'
  }],
  component: RadioFilterSelector
})

export const userTag = () : FilterSelector => ({
  id: 'userTag',
  type: 'dynamic',
  name: 'User tag',
  items: [],
  component: DynamicFilterSelector,
  fetchUrl: '/contact/userTag?q='
})
